import StatelessPageEdit from './StatelessPageEdit.container';

export default StatelessPageEdit;
